import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router, RouterModule} from '@angular/router';
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {ApiAgentService} from '../../../services/api-agent.service';
import {GlobalLoaderService} from '../../../services/global-loader.service';
import {HttpClient} from '@angular/common/http';
import {EnvironmentService} from '../../../services/environment.service';
import {getEditorDefaults, PinturaDefaultImageWriterResult} from '@pqina/pintura';
import {firstValueFrom} from 'rxjs';
import {Collection} from '../../../models/collection';
import {Product} from '../../../models/product';
import {CommonModule} from '@angular/common';

declare var Snackbar: any;
declare var FileUploadWithPreview: any;
declare var Tagify: any;
declare var $: any;

// noinspection DuplicatedCode
@Component({
  selector: 'app-category',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, TranslateModule, RouterModule],
  templateUrl: './category.component.html', //latertodo: fix the side padding of the form. The form is attached to the left of the screen.
  styleUrls: ['./category.component.scss']
})
export class CategoryComponent implements OnInit {

  @ViewChild('productsTextArea') productsTextArea: ElementRef;
  collectionForm: FormGroup;
  collection: Collection;
  /* ************************ */

  loading: boolean;

  // for the image thumbnail
  loadingThumbnailPictures: boolean;
  serverCollectionThumbnailImage: any;
  collectionThumbnailImageUploader: any;
  collectionThumbnailPinturaOptions: any;
  collectionThumbnailUrl: any;
  collectionThumbnailImageFile: any;

  // for the banner picture
  loadingBannerPictures: boolean;
  serverCollectionBannerImage: any;
  collectionBannerImageUploader: any;
  collectionBannerPinturaOptions: any;
  collectionBannerUrl: any;
  collectionBannerImageFile: any;


  submitted: boolean;
  formStatus: string;
  collectionId: string;
  collectionFromServer: Collection;

  subAccountType: any;
  subAccountGovId: any;
  isAccountant: boolean;
  isManager: boolean;
  isSales: boolean;
  isMerchant: boolean;
  lang: any;

  allProducts: Product[];
  tagify: any;

  checkPermission() {
    this.activatedRouter.queryParams.subscribe(params => {
      let perms = this.environmentService.checkPermission(params['type'], params['govId']);
      this.isAccountant = perms.isAccountant;
      this.isSales = perms.isSales;
      this.isManager = perms.isManager;
      this.isMerchant = perms.isMerchant;
    });
  }

  constructor(private activatedRouter: ActivatedRoute,
              private translate: TranslateService,
              private loader: GlobalLoaderService,
              private environmentService: EnvironmentService,
              private http: HttpClient,
              private formBuilder: FormBuilder,
              private router: Router,
              private api: ApiAgentService) {
  }

  async ngOnInit() {
    this.lang = await firstValueFrom(this.translate.get('lang'));

    this.collectionForm = this.formBuilder.group({
      name_ar: ['', [Validators.required]],
      name: [''],
      bannerImageBytes: [''],
      iconImageBytes: [''],
      products: ['']
    });

    this.loading = true;

    this.activatedRouter.params.subscribe(async params => {

      this.formStatus = params['status'];
      this.collectionId = params['collectionId'];

      console.log('form status', this.formStatus);
      console.log('collection id', this.collectionId);

      if (this.collectionId) {
        await this.loadCollectionData();
      }

      this.allProducts = await this.api.loadProducts();
      await this.loadResources();
      this.loading = false;
      this.checkPermission();
      setTimeout(async () => {
        this.loadProductsTags(this.allProducts);
      }, 1000);
    });
    window.addEventListener('fileUploadWithPreview:imagesAdded', (e) => this.imagesAdded(e));
  }

  async imagesAdded(e: any) {
    console.log('category - image added e', e);

    let file = e.detail.cachedFileArray.length > 0 ? e.detail.cachedFileArray[0] : null;
    let image64 = await this.fileToBase64(file);
    if (file == null) {
      return;
    }

    console.log('file', file);

    let bigFileSize = file.size > 2097152;


    // if the upload from the three images inputs, check the size of the image 2MB.
    if (!bigFileSize) {
      console.log('file size', file.size);
      let quality = 2097152 / file.size;

      if (e.detail.uploadId == 'thumbnailCollectionImage') {
        console.log('thumbnail');
        this.collectionThumbnailPinturaOptions = this.buildPqinaEditorOptions('thumbnail', 800, 800, quality);
      } else if (e.detail.uploadId == 'bannerCollectionImage') {
        console.log('banner');
        this.collectionBannerPinturaOptions = this.buildPqinaEditorOptions('banner', 1600, 900, quality); // latertodo: this line work only for the first time, but next time image size not set.
        console.log('collection banner pintura options', this.collectionBannerPinturaOptions);
      }
    } else {
      console.log('file big size', file.size);
      console.log('file big', bigFileSize);
      this.showToast('File size is bigger than 2MB - حجم الملف اكبر من ٢ ميجابايت');
    }

    if (e.detail.uploadId == 'thumbnailCollectionImage') {
      this.collectionThumbnailUrl = image64;
    } else if (e.detail.uploadId == 'bannerCollectionImage') {
      this.collectionBannerUrl = image64;
    }
  }

  async loadCollectionData() {
    this.collectionFromServer = await this.api.loadCollection(this.collectionId);
    let products = this.collectionFromServer.products;
    this.collectionForm.patchValue({
      name: this.collectionFromServer.name,
      name_ar: this.collectionFromServer.name_locale && this.collectionFromServer.name_locale[this.lang] ? this.collectionFromServer.name_locale[this.lang] : null, // latertodo: ensure that this.lang is exists.
      products: products != null && typeof products == 'string' ? JSON.parse(products) : products
    });
  }

  private fileToBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  }

  //
  async loadResources() {
    // load external javascript libraries.
    await this.loader.loadExternalStyles('/plugins/notification/snackbar/snackbar.min.css');
    await this.loader.loadExternalStyles('/plugins/file-upload/file-upload-with-preview.min.css');
    await this.loader.loadExternalScript('/plugins/notification/snackbar/snackbar.min.js');
    await this.loader.loadExternalScript('/plugins/file-upload/file-upload-with-preview.min.js');
    await this.loader.loadExternalScript('https://cdn.jsdelivr.net/npm/@yaireo/tagify');
    await this.loader.loadExternalScript('https://cdn.jsdelivr.net/npm/@yaireo/tagify/dist/tagify.polyfills.min.js');
    await this.loader.loadExternalStyles('https://cdn.jsdelivr.net/npm/@yaireo/tagify/dist/tagify.css');

    this.collectionThumbnailPinturaOptions = this.buildPqinaEditorOptions('thumbnail', 800, 800);
    this.collectionBannerPinturaOptions = this.buildPqinaEditorOptions('banner', 1600, 900);

    // load thumbnail picture from the server
    if (this.collectionFromServer && this.collectionFromServer.iconImageBytes) {
      this.loadingThumbnailPictures = true;
      this.serverCollectionThumbnailImage = this.collectionFromServer.iconImageBytes;
      this.collectionThumbnailUrl = this.serverCollectionThumbnailImage ? 'data:image/png;base64,' + this.serverCollectionThumbnailImage : this.environmentService.getRest() + '/openApi/downloadCollectionThumbnailImageBytes/' + this.collectionFromServer.id;
      this.loadingThumbnailPictures = false;
      this.collectionThumbnailImageUploader = await this.loadImageUploaderWithImage('thumbnailCollectionImage', this.collectionThumbnailUrl);
    } else {
      this.collectionThumbnailUrl = null;
      this.collectionThumbnailImageUploader = await this.loadImageUploaderWithImage('thumbnailCollectionImage', './assets/img/no-image.png');
    }

    // load banner picture
    if (this.collectionFromServer && this.collectionFromServer.bannerImageBytes) {
      this.loadingBannerPictures = true;
      this.serverCollectionBannerImage = this.collectionFromServer.bannerImageBytes;
      this.collectionBannerUrl = this.serverCollectionBannerImage ? 'data:image/png;base64,' + this.serverCollectionBannerImage : this.environmentService.getRest() + '/openApi/loadCollectionBannerImage/' + this.collectionFromServer.bannerImageBytes;
      this.loadingBannerPictures = false;
      this.collectionBannerImageUploader = await this.loadImageUploaderWithImage('bannerCollectionImage', this.collectionBannerUrl);
    } else {
      this.collectionBannerUrl = null;
      this.collectionBannerImageUploader = await this.loadImageUploaderWithImage('bannerCollectionImage', './assets/img/no-image.png');
    }
  }

  // @ts-ignore
  get f() {
    return this.collectionForm.controls;
  }

  showToast(msg) {
    Snackbar.show({
      text: msg,
      pos: 'bottom-center'
    });
  }

  cleanThumbnailImage(thumbnailImage) {
    const prefixRegex = /^data:image\/\w+;base64,/;
    if (prefixRegex.test(thumbnailImage)) {
      return thumbnailImage.replace(prefixRegex, '');
    }
    return thumbnailImage;
  }

  async sendDataToServer(thumbnailImage, bannerImage) {
    console.log('thumbnail image', thumbnailImage);
    console.log('banner image', bannerImage);

    thumbnailImage = this.cleanThumbnailImage(thumbnailImage);
    bannerImage = this.cleanThumbnailImage(bannerImage);

    console.log('thumbnail image', thumbnailImage);
    console.log('banner image', bannerImage);

    let name = this.collectionForm.value['name'];
    let name_ar = this.collectionForm.value['name_ar'];
    try {

      let collection: Collection = {
        id: this.formStatus == 'edit' ? this.collectionFromServer.id : null,
        name: name,
        name_locale: {ar: name_ar},
        merchantId: null,
        bannerImageBytes: this.cleanThumbnailImage(bannerImage),
        iconImageBytes: this.cleanThumbnailImage(thumbnailImage),
        products: this.collectionForm.value['products']
      };

      let newCollection: Collection = await this.api.postCollection(collection);
      console.log('edited collection', newCollection);
      this.collectionId = newCollection.id;
      await this.loadCollectionData();

      this.showToast(await firstValueFrom(this.translate.get('Collection saved successfully')));
      this.router.navigate(['/private', 'collections']).then();
    } catch (e) {
      console.log('error', e);
      this.showToast(await firstValueFrom(this.translate.get('Could not save the collection')));
    } finally {
      this.loading = false;
    }
  }

  private readFileFromAsset(assetName) {
    return new Promise(resolve => {
      this.http.get('./assets/img/' + assetName, {responseType: 'blob'}).subscribe((res => {
            const reader = new FileReader();
            reader.onloadend = () => {
              let base64data = reader.result;
              resolve(base64data);
            };
            reader.readAsDataURL(res);
          }
        )
      );
    });
  }

  async submitForm() {
    this.submitted = true;
    if (this.collectionThumbnailImageFile == null && this.thumbnailCollectionEditor != null) {
      console.log('collection thumbnail image file', this.collectionThumbnailImageFile);
      await this.thumbnailCollectionEditor.editor.processImage();
      console.log('collection thumbnail image file', this.collectionThumbnailImageFile);
    }
    if (this.collectionBannerImageFile == null && this.bannerCollectionEditor != null) {
      console.log('collection banner image file', this.collectionBannerImageFile);
      await this.bannerCollectionEditor.editor.processImage();
      console.log('collection banner image file', this.collectionBannerImageFile);
    }

    let name = this.collectionForm.value['name'];
    let name_ar = this.collectionForm.value['name_ar'];

    console.log('name', name);
    console.log('name ar', name_ar);

    if (this.collectionForm.valid) {
      this.loading = true;
      let thumbnailImage64 = null;
      let bannerImage64 = null;
      if (this.collectionThumbnailImageFile) {
        thumbnailImage64 = await this.fileToBase64(this.collectionThumbnailImageFile);
      }
      if (this.collectionBannerImageFile) {
        bannerImage64 = await this.fileToBase64(this.collectionBannerImageFile);
      }
      if (!thumbnailImage64 && !this.serverCollectionThumbnailImage) {
        thumbnailImage64 = await this.readFileFromAsset('no-image-300x300.jpg');
      }
      if (!bannerImage64 && !this.serverCollectionBannerImage) {
        bannerImage64 = await this.readFileFromAsset('no-image-1600x1200.jpg');
      }
      await this.sendDataToServer(thumbnailImage64, bannerImage64);
    } else {
      console.log('errors', this.f);
    }
  }

  buildPqinaEditorOptions(collectionImageState, width, height, quality = 1): any {

    console.log('width of editor', width);
    console.log('width of height', height);

    return getEditorDefaults({
      imageWriter: {
        quality: quality,
        targetSize: {
          width: width,
          height: height,
          fit: 'contain',
          upscale: false,
        },
        preprocessImageState: (imageState) => {
          // create new annotation array
          imageState.annotation = imageState.annotation.map((shape) => {
            // this is not a text shape so skip
            if (!shape.text) {
              return shape;
            }

            // replace placeholders in text properties
            shape.text = shape.text.replace(/{name}/g, 'John Connor');

            return shape;
          });

          // return updated image state
          return imageState;
        },
        store: (state, options, onprogress) => {
          console.log('state', state);
          console.log('options', options);
          console.log('onprogress', onprogress);

          return new Promise((resolve) => {
            switch (collectionImageState) {
              case 'thumbnail':
                this.collectionThumbnailImageFile = state.dest;
                break;
              case 'banner':
                this.collectionBannerImageFile = state.dest;
                break;
            }
            resolve(state);
          });
        }
      }
    });
  }

  @ViewChild('thumbnailCollectionEditor') thumbnailCollectionEditor?: any;
  @ViewChild('bannerCollectionEditor') bannerCollectionEditor?: any;

  private async loadImageUploaderWithImage(imageUploaderId, imageUrl = null) {
    console.log('load image uploader with image');
    // load labels
    let chooseFileLbl = await firstValueFrom(this.translate.get('Choose collection image'));
    let browseLbl = await firstValueFrom(this.translate.get('Browse'));
    let imageUploader: any;
    imageUploader = new FileUploadWithPreview(imageUploaderId, {
      text: {
        chooseFile: chooseFileLbl,
        browse: browseLbl
      },
      images: {
        baseImage: imageUrl
      }
    });
    return imageUploader;
  }

  loadProductsTags(products: Product[]) {
    let nativeElement = this.productsTextArea.nativeElement;
    // map products to {value: 'product id', full: 'product name'}
    let choices = products.map(product => {
      return product.id + '-' + product.title;
    });
    console.log('choices', choices);

    // tagify as textarea
    this.tagify = new Tagify(nativeElement, {
      whitelist: choices,
      dropdown: {
        enabled: 0, // shows the suggestion dropdown once field is focused
        RTL: true,
        escapeHTML: false // allows HTML inside each suggestion item
      },
      callbacks: {
        'add': (e) => {
          console.log('add', e);
          this.collectionForm.patchValue({products: e.detail.tagify.value.map(tag => tag.value)});
          console.log('collection form', this.collectionForm.value);
        },
        'remove': (e) => {
          console.log('add', e);
          this.collectionForm.patchValue({products: e.detail.tagify.value.map(tag => tag.value)});
          console.log('collection form', this.collectionForm.value);
        },
      }
    });
    // this.tagify.addTags(this.collectionForm.value['products']);
  }


  handleEditorProcess($event: PinturaDefaultImageWriterResult) {
    console.log('handle editor process result', $event);
  }

  // all products to tagify
  addAllProducts() {
    this.tagify.addTags(this.allProducts.map(product => {
      return {value: product.id + '-' + product.title};
    }));
    this.collectionForm.patchValue({products: this.tagify.value.map(tag => tag.value)});
    console.log('collection form', this.collectionForm.value);
  }
}
